var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeatureCardTwo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.58423 4.5293C7.82206 4.52942 8.05552 4.59315 8.26043 4.71389C8.46533 4.83463 8.63421 5.00798 8.74956 5.21596L10.3809 8.1533C10.486 8.34277 10.5434 8.55502 10.5481 8.77166C10.5527 8.98831 10.5045 9.20282 10.4076 9.39663L8.83623 12.5393C8.83623 12.5393 9.29156 14.88 11.1969 16.786C13.1029 18.6913 15.4356 19.1393 15.4356 19.1393L18.5782 17.568C18.7721 17.4709 18.9868 17.4226 19.2035 17.4273C19.4203 17.4319 19.6327 17.4894 19.8222 17.5946L22.7689 19.2333C22.9765 19.3489 23.1494 19.5179 23.2698 19.7228C23.3902 19.9277 23.4536 20.161 23.4536 20.3986V23.7806C23.4536 25.5033 21.8536 26.7473 20.2216 26.1966C16.8696 25.066 11.6669 22.912 8.36823 19.6146C5.07089 16.3166 2.91756 11.1133 1.78622 7.7613C1.23556 6.1293 2.47956 4.5293 4.20223 4.5293H7.58423Z",
    stroke: "#5D34F3",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 7.99992H16V1.33325H24V3.33325L27.3333 1.99992V7.33325L24 5.99992V7.99992Z",
    stroke: "#5D34F3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatureCardTwo);
export default __webpack_public_path__ + "static/media/featureCardTwo.9364bb63e025eee8404372d3b4ec56b1.svg";
export { ForwardRef as ReactComponent };